import React, { useEffect, useState } from 'react';
import axios from 'axios';

const { nonce, blocks: initialBlocks, activated_blocks } = window.UNIVERSAL_BLOCKS;

const Blocks = () => {
    const [blocks, setBlocks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [allEnabled, setAllEnabled] = useState(false);
    const [savingStatus, setSavingStatus] = useState(''); // 'saving' or 'saved'

    useEffect(() => {
        const fetchBlocks = async () => {
            try {
                // const response = await axios.get('/wp-json/universal-blocks/v1/blocks');
                const blocksArray = Object.entries(initialBlocks).map(([key, value]) => ({
                    ...value,
                    key,
                    // enabled: value.status === 'active',
                    enabled: Object.keys(activated_blocks).includes(key),
                }));
                setBlocks(blocksArray);
                setAllEnabled(blocksArray.every(block => block.enabled));
            } catch (error) {
                console.error('Error fetching the blocks:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBlocks();
    }, []);

    const showSavingModal = (status) => {
        setSavingStatus(status);
        if (status === 'saved') {
            setTimeout(() => setSavingStatus(''), 2000); // Hide modal after 2 seconds
        }
    };

    const handleButtonClick = async (buttonType) => {
        const type = buttonType === 'enable' ? 'enable' : 'disable';
        setAllEnabled(type === 'enable');
        setBlocks(blocks.map(block => ({ ...block, enabled: type === 'enable' })));

        try {
            showSavingModal('saving');
            await axios.post('/wp-json/universal-blocks/v1/activate', { type });
            showSavingModal('saved');
        } catch (error) {
            console.error('Error updating all blocks:', error);
        }
    };

    const handleCheckboxChange = async (index) => {
        const updatedBlocks = blocks.map((block, i) => {
            if (i === index) {
                const updatedBlock = { ...block, enabled: !block.enabled };

                showSavingModal('saving');
                axios.post(`/wp-json/universal-blocks/v1/blocks/${updatedBlock.key}`, { enabled: updatedBlock.enabled })
                    .then(() => showSavingModal('saved'))
                    .catch(error => {
                        console.error(`Error updating block ${updatedBlock.key}:`, error);
                        showSavingModal('');
                    });

                return updatedBlock;
            }
            return block;
        });
        setBlocks(updatedBlocks);
    };

    return (
        <div>
            <div className="flex mb-6 bg-white px-6 py-4 rounded justify-between">
                <div>
                    <h2 className="font-semibold text-lg text-blue-950">Global Control</h2>
                    <p className="text-blue-950">Use the toggle button to activate or deactivate all the blocks of Universal Blocks at once.</p>
                </div>
                <div className="flex gap-4">
                    <button
                        className={`px-6 py-2 rounded ${!allEnabled ? 'bg-blue-500 text-white' : 'bg-blue-50 text-blue-500 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleButtonClick('disable')}
                    >
                        Disable All
                    </button>
                    <button
                        className={`px-6 py-2 rounded ${allEnabled ? 'bg-blue-500 text-white' : 'bg-blue-50 text-blue-500 hover:bg-blue-500 hover:text-white'}`}
                        onClick={() => handleButtonClick('enable')}
                    >
                        Enable All
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                {isLoading ? (
                    Array.from({ length: 8 }, (_, index) => (
                        <div key={index} className="animate-pulse bg-gray-200 p-4 rounded-md shadow-md flex items-center">
                            <div className="w-12 h-12 bg-gray-300 rounded-full mr-4"></div>
                            <div className="flex-1">
                                <div className="h-4 bg-gray-300 w-3/4 mb-2 rounded"></div>
                                <div className="h-3 bg-gray-300 w-1/2 rounded"></div>
                            </div>
                        </div>
                    ))
                ) : (
                    blocks.map((block, index) => (
                        <div data-block={block.key} key={block.key} className="bg-white p-4 rounded-md shadow-md flex items-center">
                            <div className="flex-shrink-0">
                            <img className='' src = {block.icon} alt={block.title}/>
                            </div>
                            <div className="ml-4 flex-1">
                                <div className="text-lg font-medium text-gray-900">{block.title}</div>
                            </div>
                            <p className="mr-4 text-sm font-medium text-gray-900 dark:text-gray-300">{block.package}</p>

                            {block.status !== 'upcoming' && (
                                <label className="relative cursor-pointer">
                                    <input
                                        type="checkbox"
                                        className="sr-only peer"
                                        checked={block.enabled}
                                        onChange={() => handleCheckboxChange(index)}
                                    />
                                    <div className="w-11 h-3 flex items-center bg-gray-300 rounded-full peer peer-checked:after:translate-x-full after:absolute after:left-0 peer-checked:after:-left-1 after:bg-gray-300 peer-checked:after:bg-[#007bff] after:border after:border-gray-300 peer-checked:after:border-[#007bff] after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-[#007bff]">
                                    </div>
                                </label>
                            )}

                            
                        </div>
                    ))
                )}
            </div>

            {savingStatus && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded shadow-md">
                        <h2 className="text-sm font-semibold text-blue-500 p-0 m-0">
                            {savingStatus === 'saving' ? 'Saving...' : 'Saved'}
                        </h2>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Blocks;
